import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'timeAgo',
  standalone: true,
  pure: true, // optimiza rendimiento
})
export class TimeAgoPipe implements PipeTransform {
  transform(value: Date | string): string {
    if (!value) return '';

    const now = new Date().getTime();
    const date = new Date(value).getTime();
    const diffSeconds = Math.floor((now - date) / 1000);

    if (diffSeconds < 60) {
      return 'Hace unos segundos';
    }

    const minutes = Math.floor(diffSeconds / 60);
    if (minutes < 60) {
      return `Hace ${minutes} minuto${minutes > 1 ? 's' : ''}`;
    }

    const hours = Math.floor(minutes / 60);
    if (hours < 24) {
      return `Hace ${hours} hora${hours > 1 ? 's' : ''}`;
    }

    const days = Math.floor(hours / 24);
    if (days === 1) {
      return 'Ayer';
    }

    if (days < 30) {
      return `Hace ${days} días`;
    }

    const months = Math.floor(days / 30);
    if (months < 12) {
      return `Hace ${months} mes${months > 1 ? 'es' : ''}`;
    }

    const years = Math.floor(months / 12);
    return `Hace ${years} año${years > 1 ? 's' : ''}`;
  }
}
